<template>
<div>
        <div class="tunnel columns">
        <h2>桥梁自动化监测</h2>
        <div class="all">
          <p>
              桥梁在交通、军事和社会生活等方面有着重要的战略意义，我国现有公路桥5000余座，总长130万公里，1/3以上的桥梁都存在 结构性缺陷、不同程度的损伤和功能性失效的隐患，出现了多次重大桥梁事故。因此对桥梁结构进行质量检测和监测，已成为国内 外学术界、工程界研究的热点。
          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>监测桥梁关键结构：桥塔、桥墩、跨中等的形变、受力等情况， 为施工工艺流程和桥梁健康状况提供技术参考</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>桥塔倾斜/沉降（GNSS/测量机器人/倾斜仪）</p>
            <p>桥墩沉降（GNSS /测量机器人/静力水准）</p>
            <p>桥面沉降（GNSS /测量机器人/静力水准）</p>
            <p>线性变形（GNSS /测量机器人）</p>
            <p>扰度位移（GNSS /测量机器人/静力水准）</p>
            <p>内部应力/应变（钢筋计/应力计/应变计）</p>
            <p>钢索受力（锚索计）</p>
            <p>荷载（荷载计）</p>
            <p>气象环境（气象站）</p>
            <p>地震（加速度传感器）</p>
            <p>动态应变（光纤应变计）</p>
            <p>交通监测（视频系统）</p>

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>RocBox RT2000-GS北斗监测GNSS</p>
            <p>Topcon MS系列测量机器人</p>
            <p>Topcon DS系列测量机器人</p>
            <p>RT-DT-5100液压式静力水准</p>
            <p>RT-DT-6300测斜仪</p>
            <p>RT-VW-2300振弦式钢筋计</p>
            <p>RT-VW-2100振弦式锚索测力计</p>
            <p>RT-DT-8100系列多参数气象站</p>
            <p>RT-VW-2500振弦式荷载计</p>
            <h6>监测终端:</h6>
            <p>RocBox RT2000监测终端</p> 
            <p>RocMIoT监测物联网系列产品</p>              
        </div>    
    </div>
     <foot></foot>

</div>

</template>
<style>
.tunnel {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/solutionpage/bridge.vue